export default "__VITE_ASSET__Byg3WNlV__"